export default function () {
  $('.photo-gallery__slider').each(function () {
    const $slider = $(this);

    $slider.slick({
      slidesToShow: 2.43,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      infinite: false,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1.25,
            arrows: true,
          },
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 1.25,
            arrows: false,
          },
        },
      ],
    });
  });
}
